// contact-form JS, extracted from theme.js so it only loads where the section/block renders.
// Shared helpers come from theme.js via window.flu.sectionHelpers.
const {
  delayOffset,
  intersectionWatcher,
  register,
  shouldAnimate,
  load,
} = window.flu.sectionHelpers;

const selectors$1e = {
  headerItems: ".animation--section-introduction > *",
  animationItem: ".animation--item"
};
var animateContactForm = (node => {
  delayOffset(node, [selectors$1e.headerItems, selectors$1e.animationItem]);
  const observer = intersectionWatcher(node, true);
  return {
    destroy() {
      observer === null || observer === void 0 || observer.destroy();
    }
  };
});

register("contact-form", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateContactForm = animateContactForm(this.container);
    }
  },
  onUnload() {
    var _this$animateContactF;
    (_this$animateContactF = this.animateContactForm) === null || _this$animateContactF === void 0 || _this$animateContactF.destroy();
  }
});

load("contact-form");
